import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDhnNLQSM3_7m5uf_RU1e8PDeFiwxKWYac",
  authDomain: "pp-studio-website.firebaseapp.com",
  projectId: "pp-studio-website",
  storageBucket: "pp-studio-website.firebasestorage.app",
  messagingSenderId: "810800893728",
  appId: "1:810800893728:web:3c8bea9785855968bc1145",
  measurementId: "G-RLYJ7ZYPND"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

/* Analytics loaded lazily — does not block app startup */
if (typeof window !== "undefined") {
  import("firebase/analytics").then(({ getAnalytics }) => getAnalytics(app)).catch(() => {});
}

/* App Check — activated when REACT_APP_RECAPTCHA_SITE_KEY is set in .env
   Setup: Firebase Console → App Check → register web app with reCAPTCHA v3
   Get site key from: console.cloud.google.com/security/recaptcha */
let appCheckReady = Promise.resolve(null);
if (process.env.REACT_APP_RECAPTCHA_SITE_KEY && typeof window !== "undefined") {
  if (process.env.NODE_ENV === "development") {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  appCheckReady = import("firebase/app-check").then(({ initializeAppCheck, ReCaptchaV3Provider }) =>
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    })
  ).catch(() => null);
}

// Fetches a fresh App Check token for hand-rolled fetch() calls to the "api"
// Cloud Function (routes that go through Firebase SDKs get this attached
// automatically; a plain fetch, like the public chat widget uses, doesn't).
async function getAppCheckToken() {
  const instance = await appCheckReady;
  if (!instance) return null;
  try {
    const { getToken } = await import("firebase/app-check");
    const result = await getToken(instance, false);
    return result.token;
  } catch (_) {
    return null;
  }
}

export { app, db, storage, auth, getAppCheckToken };